import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPricing from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

const breadcrumb = [
  {
    position: 1,
    name: 'Home',
    item: '/',
  },
  {
    position: 2,
    name: 'Business',
    item: '/business',
  },
  {
    position: 3,
    name: 'Plan',
    item: '/business/plan',
  },
];
export default [
  <Route
    key="/business/plan"
    element={
      <DefaultBusinessLayout
        breadcrumb={breadcrumb}
        showContactSales={false}
        showDemoStore={false}
      />
    }
  >
    <Route path="business/plan" element={<AsyncPricing />} />
  </Route>,
  <Route
    key="/business/plan/:platform?"
    element={<DefaultBusinessLayout breadcrumb={breadcrumb} />}
  >
    <Route path="business/plan/:platform" element={<AsyncPricing />} />
  </Route>,
];
